/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/Quotes/QuotesService',[
    'jquery',
    'lodash',
    'global/all'
], function ($, _, Roc) {
    'use strict';

    var apiUrl = window.RocConfig.api.baseRocApiUrl;

    function getTempAddressId() {
        return $("#hdnTempAddressId").val();
    }

    function getAvailable(request) {
        return $.ajax({
            url: apiUrl + '/api/quote/available',
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            data: JSON.stringify(request)
        });
    }

    function getQuoteDetails(quoteId) {
        return $.ajax({
            url: apiUrl + '/api/quote/details/' +quoteId,
            type: 'GET',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8'
        });
    }

    function loadQuote(quoteId) {
        return $.proxyRequest({
            url: '/api/quote/load',
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            serverCompleteAction: 'UpdateCurrentOrderId',
            data: JSON.stringify({
                quoteId: quoteId,
                orderId: '{orderId}',
                tempAddressId: getTempAddressId()
            })
        });
    }


    var QuotesService = {
        getAvailable: getAvailable,
        getQuoteDetails: getQuoteDetails,
        loadQuote: loadQuote
    };

    Roc.Logger.debug('QuotesService.js Loaded:', QuotesService);

    return QuotesService;
});
